import type { DashboardUser } from "../../../schema/user"

export const UPDATE_INFO: 'user/UPDATE_INFO' = 'user/UPDATE_INFO'
export const UPDATE_SETTINGS: 'user/UPDATE_SETTINGS' = 'user/UPDATE_SETTINGS'
export const LOG_OUT: 'user/LOG_OUT' = 'user/LOG_OUT'
export const SET_INFO: 'user/SET_INFO' = 'user/SET_INFO'
export const UPDATE_DEFAULT_LOGO: 'user/UPDATE_DEFAULT_LOGO' = 'user/UPDATE_DEFAULT_LOGO'
export const UPLOAD_DEFAULT_LOGO: 'user/UPLOAD_DEFAULT_LOGO' = 'user/UPLOAD_DEFAULT_LOGO'
export const DELETE_DEFAULT_LOGO: 'user/DELETE_DEFAULT_LOGO' = 'user/DELETE_DEFAULT_LOGO'

export type UpdateUserInfoAction = {
  payload: Partial<DashboardUser>,
  type: typeof UPDATE_INFO,
}

export type UpdateUserSettingsAction = {
  payload: Partial<DashboardUser>,
  type: typeof UPDATE_SETTINGS,
}

type LogUserOutAction = {
  type: typeof LOG_OUT,
}

type SetUserInfoAction = {
  payload: Partial<DashboardUser>,
  type: typeof SET_INFO,
}

export type UpdateDefaultLogoAction = {
  payload: string,
  type: typeof UPDATE_DEFAULT_LOGO,
}

export type UploadDefaultLogoAction = {
  payload: {
    file: Blob,
    setFieldValue: Function,
    setFieldError: Function,
  },
  type: typeof UPLOAD_DEFAULT_LOGO,
}

export type DeleteDefaultLogoAction = {
  type: typeof DELETE_DEFAULT_LOGO,
}

export type UserActions =
  | UpdateUserInfoAction
  | LogUserOutAction
  | SetUserInfoAction
  | UpdateDefaultLogoAction
  | UploadDefaultLogoAction
  | DeleteDefaultLogoAction

export const updateUserInfo = (
  user: Partial<UpdateUserInfoAction['payload']>,
): UpdateUserInfoAction => ({
  payload: user,
  type: UPDATE_INFO,
})

export const updateUserSettings = (
  user: Partial<UpdateUserSettingsAction['payload']>,
): UpdateUserSettingsAction => ({
  payload: user,
  type: UPDATE_SETTINGS,
})

export const logUserOut = (): LogUserOutAction => ({ type: LOG_OUT })

export const setUserInfo = (
  user: SetUserInfoAction['payload']
): SetUserInfoAction => ({
  payload: user,
  type: SET_INFO,
})

export const uploadDefaultLogo = (
  payload: UploadDefaultLogoAction['payload']
): UploadDefaultLogoAction => ({
  payload,
  type: UPLOAD_DEFAULT_LOGO,
})

export const updateDefaultLogo = (
  payload: string,
): UpdateDefaultLogoAction => ({
  payload,
  type: UPDATE_DEFAULT_LOGO,
})

export const deleteDefaultLogo = (): DeleteDefaultLogoAction => ({
  type: DELETE_DEFAULT_LOGO,
})
